<template>
  <div class="container">
    <a-progress
      type="dashboard"
      :percent="percent"
      :strokeColor="strokeColor"
      :strokeWidth="strokeWidth"
      :width="width"
    >
      <template #format="percent">
        <div class="percent-style">{{ percent }}{{ unit }}</div>
        <!-- <div class="type-style">{{ type }}</div> -->
      </template>
    </a-progress>
    <div class="progress-title-name">{{ titleName }}</div>
  </div>
</template>
<script>
export default {
  name: "ProgressCharts", //会员分类组件
  props: {
    percent: {
      //百分比
      type: Number,
      default: 0,
      require: true,
    },
    // type: {
    //   // 类型
    //   type: String,
    //   default: "自网",
    //   require: true,
    // },
    titleName: {
      // 标题名称
      type: String,
      default: "普通会员",
      require: true,
    },
    strokeWidth: {
      type: Number,
      default: 10,
    },
    width: {
      type: Number,
      default: 88,
    },
    strokeColor: {
      type: String,
      default: "#FBBE02",
    },
    unit: {
      type: String,
      default: "%",
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  .percent-style {
    color: #0A1F44;
  }
  // .type-style {
  //   color: #8690a3;
  //   padding-top: 10px;
  //   font-size: 12px;
  // }
  .progress-title-name {
    box-sizing: border-box;
    padding: 2px 6px;
    // margin-top: 6px;
    border-radius: 4px;
    font-size: 12px;
  }
}
</style>
